import axios from "axios";
const nook = function () { };
const handler = function (data) {
  return Promise.resolve(data);
};

export default function ({ decorateConfig }) {
  typeof decorateConfig === "function" || (decorateConfig = handler);
  /**
   * 上传使用FormData
   * config.progress接受进度事件
   */
    return function (config) {

    const progress = config.progress || nook;
    
    if (!(config.data instanceof FormData)) {
      const formData = new FormData();

      for (let key in config.data) {
        formData.append(key, config.data[key]);
      }

      config.data = formData;
    }

    config.headers || (config.headers = {});

    if (config.data && config.data.get && config.data.get("file")) {
        config.headers["Content-Type"] = "multipart/form-data";
    }

    config.method = "POST";

    config.onUploadProgress = function (event) {
      if (event.lengthComputable) {
        let percent = (event.loaded / event.total) * 100;

        if (percent >= 100) {
          percent = 99.99;
        }

        progress(percent);
      }
    };

    return decorateConfig(config)
      .then(function (config) {
        return axios(config);
      })
      .then(function (response) {
        progress(100);
        return response.data;
      }).then(function (data) {
        if (data.statusCode == "0") {
          return data;
        } else {
          const error = new Error(data.msg);
          error.statusCode = data.statusCode;
          return Promise.reject(error);
        }
      });
  };
}
